import styled from "styled-components";
import HomeBG from "../../../assets/images/backGrounds/homePageBG.webp";
export const Styles = styled.div`
  header {
    background-image: url(${HomeBG});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-bottom-left-radius: 350px;
    border-bottom-right-radius: 350px;
    margin-bottom: 100px;
    min-height: 90vh;
  }
  header .container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  header .header-video {
    height: 450px;
  }
  header .header-video img {
    width: 100%;
    max-height: 450px;
    object-fit: contain;
    border-radius: 7px;
  }
  header .header-video .img-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  header .container .row {
    margin-top: 180px;
    padding-bottom: 50px;
    align-items: center;
    justify-content: space-between;
  }
  header .container .row > * {
    padding: 0;
  }
  .header-data {
    width: 100%;
  }

  header .header-content .header-description {
    width: 80%;
    color: var(--dark-color);
  }
  header .header-content .btn-primary {
    font-size: 20px;
  }
  header .header-content h1 {
    font-size: 30px;
  }
  header .header-content h2 {
    font-size: 24px;
  }
  header .video-react {
    border-radius: 15px;
    overflow: hidden;
  }
  header .video-react .video-react-poster {
    background-size: cover !important;
  }
  header .video-react:hover .video-react-big-play-button-center {
    background: #fff !important;
  }
  header .video-react .video-react-big-play-button-center {
    display: block !important;
    border-radius: 50%;
    font-size: 25px;
    width: 70px;
    height: 70px;
    box-shadow: 0px 0px 40px var(--light-purple);
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: #fff;
    transition: 0.3s !important;
  }
  header .video-react .video-react-big-play-button-center.big-play-button-hide {
    display: none !important;
  }
  header .video-react .video-react-big-play-button-center:hover {
    background: var(--dark-purple) !important;
  }
  header .video-react .video-react-big-play-button-center::before {
    position: relative !important;
    font-family: "Font Awesome 6 Free";
    font-weight: 900;
    width: 40px;
    height: 40px;
    content: "\f04b" !important;
    color: var(--dark-purple);
  }
  header .video-react .video-react-big-play-button-center:hover::before {
    color: #fff;
  }
  .header-content {
    padding-inline-end: 30px !important;
  }
  @media (max-width: 991px) {
    header {
      min-height: 800px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      border-bottom-left-radius: 150px;
      border-bottom-right-radius: 150px;
    }
    header .container .row {
      text-align: center;
      gap: 40px;
    }
    header .header-content .header-description {
      width: 100%;
    }
    .header-content {
      padding-inline-end: 0px !important;
    }
  }
  @media (max-width: 768px) {
    header {
      background: #fff;
    }
    header .floating-card {
      font-size: 15px;
      transform: translateY(10%);
      gap: 30px;
      padding: 40px 30px;
    }
    header .floating-card .item .count {
      font-weight: bold;
      font-size: 16px;
    }
    header .floating-card .item:nth-child(2) {
      padding-inline: 30px;
    }
  }
  .continue-education{
    /* display: flex;
    align-items: center;
    justify-content: center; */
    width: 100%;
  }
`;
